import { render, staticRenderFns } from "./btn_component_avatar_icon.vue?vue&type=template&id=6da6d05c&scoped=true"
import script from "./btn_component_avatar_icon.vue?vue&type=script&lang=js"
export * from "./btn_component_avatar_icon.vue?vue&type=script&lang=js"
import style0 from "./btn_component_avatar_icon.vue?vue&type=style&index=0&id=6da6d05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6d05c",
  null
  
)

export default component.exports